<footer>
  <span *ngIf="!user"><a class="button" (click)="saveUrl('login')">Login</a>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
  <span><a href="https://www.writtenwordmedia.com/privacy-policy/" target="_blank">Terms of Service & Privacy</a></span>
  |
  <span><a href="javascript:;" (click)="contactForm()">Contact Support</a></span>
  <span *ngIf="!user">&nbsp;&nbsp;|&nbsp;&nbsp;<a class="button" (click)="saveUrl('signup')">Signup</a></span>
  <br><span style="font-size: 10px; color: silver;">Version 5.0.8</span>
</footer>
